class window.ANModelListController
  constructor: ->
    @modelsMap = {}